import React from 'react';
import ShowCaseDialog, { IShowCaseStep } from '../../../Shared/ShowCaseDialog';
import { useCallback, useState, useEffect } from 'react';
import getShowCasePhysicalElementsSteps from './stepsData';
import { checkStorage } from 'helpers/checkStorage';
import { storageService } from 'services/StorageService';
const STORAGE_SHOW_CASE_KEY = 'admin:sun:hide-showcase-physycal';
const ELEMENTS_FAQ_LINK = 'https://ajuda.eduzz.com/?article=checkout-elements-sun';
const showCaseSteps: IShowCaseStep[] = getShowCasePhysicalElementsSteps();

function ShowCasePhysicalElements() {
  const [open, setOpen] = useState(true);
  const [step, setStep] = useState(0);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const goToStep2 = useCallback(() => {
    setStep(1);
  }, []);

  const openElementsFAQ = useCallback(() => {
    window.open(ELEMENTS_FAQ_LINK);
  }, []);

  const finishShowCase = useCallback(() => {
    handleClose();

    storageService.setLocal(STORAGE_SHOW_CASE_KEY, 'true');
  }, []);

  useEffect(() => {
    showCaseSteps[0].primaryButtonHandleClick = goToStep2;
    showCaseSteps[0].secondaryButtonHandleClick = handleClose;
    showCaseSteps[1].primaryButtonHandleClick = finishShowCase;
    showCaseSteps[1].secondaryButtonHandleClick = openElementsFAQ;

    let hideShowCase: string;
    if (checkStorage()) {
      hideShowCase = storageService.getLocal(STORAGE_SHOW_CASE_KEY);
    }

    setOpen(hideShowCase ? !Boolean(hideShowCase) : true);
  }, []);

  return <ShowCaseDialog currentStep={step} steps={showCaseSteps} open={open} onClose={handleClose} />;
}

export default ShowCasePhysicalElements;
